<template>
    <aside class="sidebar">
        <SearchBar/>
        <div class="filter">
            <h6 class="filter-title">
                <span class="bi bi-currency-dollar"></span>Price
            </h6>
            <div class="range-container">
                <div class="range-from">
                    <p>Price from:</p>
                    <h6>{{ priceRange[0] | filterPrice }}</h6>
                </div>
                <div class="range-to">
                    <p>Price to:</p>
                    <h6>{{ priceRange[1] | filterPrice }}</h6>
                </div>
            </div>
            <VueSimpleRangeSlider
                :key="maxPrice"
                style="max-width: 100%"
                :min="0"
                :max="maxPrice"
                v-model="priceRange"/>
        </div>
        <div class="filter" v-if="typesAvailable.length > 0">
            <h6 class="filter-title">Type</h6>
            <div class="form-check" v-for="(tag, index) in typesAvailable" :key="index">
                <input class="form-check-input ml-0" type="checkbox"  @click="filterToggle(tag, 'type')">
                <label class="form-check-label">
                    {{ tag }}
                </label>
            </div>
        </div>
        <div class="filter" v-if="conditionsAvailable.length > 0">
            <h6 class="filter-title">Condition</h6>
            <div class="form-check" v-for="(tag, index) in conditionsAvailable" :key="index">
                <input class="form-check-input ml-0" type="checkbox"  @click="filterToggle(tag, 'condition')">
                <label class="form-check-label">
                    {{ tag }}
                </label>
            </div>
        </div>
        <div class="filter" v-if="tagsAvailable.length > 0">
            <h6 class="filter-title">Brand</h6>
            <div class="form-check" v-for="(tag, index) in tagsAvailable" :key="index">
                <input class="form-check-input ml-0" type="checkbox"  @click="filterToggle(tag, 'brand')">
                <label class="form-check-label">
                    {{ tag }}
                </label>
            </div>
<!--            <FormCheck :value="!tags.length" @click="tags = []">All tags</FormCheck>-->
<!--            <FormCheck v-for="(tag, index) in tagsAvailable" :key="index" :name="tag" :value="tags.includes(tag)" @click="tags.push(tag)">{{ tag }}</FormCheck>-->
        </div>
        <div class="filter-result">
            <h6>Found: <span>{{ filtered }} Products</span></h6>
        </div>
    </aside>
</template>

<script>
import FormCheck from "../elements/FormCheck";
import VueSimpleRangeSlider from 'vue-simple-range-slider'
import {mapGetters} from "vuex";
import SearchBar from "../elements/SearchBar.vue";
export default {
    name: "ProductsFilter",
    components: {SearchBar, FormCheck, VueSimpleRangeSlider},
    props: {
        filtered: 0,
        tagsAvailable: {
            type: Array,
            default: () => []
        },
        typesAvailable: {
            type: Array,
            default: () => []
        },
        conditionsAvailable: {
            type: Array,
            default: () => []
        },

    },
    computed: {
        ...mapGetters('app', ['products']),
        priceRange: {
            get: function () {
                return this.$store.getters['filter/productPriceRange']
            },
            set: function (value) {
                this.$store.commit('filter/SET_PRODUCT_PRICE_RANGE', value)
            }
        },
        tags: {
            get: function () {
                return this.$store.getters['filter/productTags']
            },
            set: function (value) {
                this.$store.commit('filter/SET_PRODUCT_TAGS', value)
            }
        },
        types: {
            get: function () {
                return this.$store.getters['filter/productTypes']
            },
            set: function (value) {
                this.$store.commit('filter/SET_PRODUCT_TYPES', value)
            }
        },
        conditions: {
            get: function () {
                return this.$store.getters['filter/productConditions']
            },
            set: function (value) {
                this.$store.commit('filter/SET_PRODUCT_CONDITIONS', value)
            }
        },
        filters: {
            get: function () {
                return {};
            },
            set: function (value) {
                this.$store.commit('filter/SET_PRODUCT_FILTERS', value)
            }
        },
        maxPrice() {
            if (this.products) {
                return Math.max(...this.products.map(i => i.price));
            } else {
                return  0;
            }
        }
    },
    watch: {
        maxPrice: {
            handler: function (newVal) {
                this.priceRange = [0, newVal];
            },
            immediate: true
        }
    },
    methods: {
        filterToggle(item, target) {
            let temp;

            switch (target) {
                case 'brand':
                    temp = [...this.tags];
                    break;
                case 'type':
                    temp = [...this.types];
                    break;
                case 'condition':
                    temp = [...this.conditions];
                    break;
                default:
                    temp = []
            }

            if(temp.includes(item)) {
                temp.splice(temp.indexOf(item), 1)
            } else {
                temp.push(item);
            }

            switch (target) {
                case 'brand':
                    this.tags = [...temp];
                    break;
                case 'type':
                    this.types = [...temp];
                    break;
                case 'condition':
                    this.conditions = [...temp];
                    break;
                default:
                    temp = []
            }
        }
    },
    mounted() {
        this.filters = {
            types: [],
            conditions: [],
            tags: []
        };
    }
}
</script>

<style scoped>

</style>
